import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-lieferanten',
    templateUrl: './lieferanten.component.html',
    styleUrls: ['./lieferanten.component.css'],
})
export class LieferantenComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
